import { useEffect, useState } from "react";

//material ui imports
import {
  Grid,
  TextField,
  Typography,
  Divider,
  Button,
  Stack,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CardHeader,
  Card,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

//project imports
import config from "../../../config";

//third party imports
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import useAxiosAuth from "../../../hooks/useAxiosAuth";
import { useNavigate, useSearchParams } from "react-router-dom";
import EmployerSpecialization from "./employer-specializations";
import { convertDateToLocalReverse } from "../../../utils/date-operations";

const EmployerForm = () => {
  //Constants
  const theme = useTheme();
  const axiosAuth = useAxiosAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  //States
  const [loading, setLoading] = useState(false);

  const stateOptions = [
    { value: "---", label: "---" },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Goa", label: "Goa" },
    { value: "Karnataka", label: "Karnataka" },
  ];

  const [employer, setEmployer] = useState();

  const formik = useFormik({
    initialValues: {
      id: 0,
      // firstName: "",
      // middleName: "",
      // lastName: "",
      name: "",
      email: "",
      dateOfBirth: convertDateToLocalReverse(new Date()),
      phoneNumber: "",
      // role: 2,
      password: "123456",
      addressLine1: "",
      addressLine2: "",
      city: "",
      taluka: "",
      district: "",
      state: "Maharashtra",
      pinCode: "",
      website: "",
      createDate: convertDateToLocalReverse(new Date()),
      modifiedDate: convertDateToLocalReverse(new Date()),
      isDeleted: false,
      deleteDate: convertDateToLocalReverse(new Date()),
      canDelete: false,
      gradeType: 1,
      registrationStatus: 2,
      contactPerson1Name: "",
      contactPerson1PhoneNumber: "",
      contactPerson1Email: "",
      contactPerson2Name: "",
      contactPerson2PhoneNumber: "",
      contactPerson2Email: "",
      contactPerson3Name: "",
      contactPerson3PhoneNumber: "",
      contactPerson3Email: "",
      contactPerson4Name: "",
      contactPerson4PhoneNumber: "",
      contactPerson4Email: "",
      contactPerson5Name: "",
      contactPerson5PhoneNumber: "",
      contactPerson5Email: "",
      latittude: "",
      longitude: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(255, "Must be 255 characters or less")
        .required("Required"),
      email: Yup.string("Enter your email")
        .max(255, "Must be 255 characters or less ")
        .email("Enter a valid email")
        .required("Required"),
      phoneNumber: Yup.string()
        .required("Required")
        .max(10, "Max 10 digits are allowed")
        .matches(
          /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
          "Phone number is not valid"
        ),
      addressLine1: Yup.string().max(255, "Must be 255 characters or less"),
      addressLine2: Yup.string().max(255, "Must be 255 characters or less"),
      city: Yup.string().max(255, "Must be 255 characters or less"),
      taluka: Yup.string().max(100, "Must be 100 characters or less"),
      district: Yup.string().max(100, "Must be 100 characters or less"),
      website: Yup.string().max(255, "Must be 255 characters or less"),
      contactPerson1Name: Yup.string().max(
        100,
        "Must be 100 characters or less"
      ),
      contactPerson1PhoneNumber: Yup.string()
        .max(10, "Must be 10 digits")
        .min(10, "Must be 10 digits")
        .matches(/^[0-9]+$/, "Must contain only digits"),
      contactPerson1Email: Yup.string()
        .email("Invalid email address")
        .max(50, "Must be 50 characters or less"),
      contactPerson2Name: Yup.string().max(
        100,
        "Must be 100 characters or less"
      ),
      contactPerson2PhoneNumber: Yup.string()
        .max(10, "Must be 10 digits")
        .min(10, "Must be 10 digits")
        .matches(/^[0-9]+$/, "Must contain only digits"),
      contactPerson2Email: Yup.string()
        .email("Invalid email address")
        .max(50, "Must be 50 characters or less"),
      contactPerson3Name: Yup.string().max(
        100,
        "Must be 100 characters or less"
      ),

      contactPerson3PhoneNumber: Yup.string()
        .max(10, "Must be 10 digits")
        .min(10, "Must be 10 digits")
        .matches(/^[0-9]+$/, "Must contain only digits"),
      contactPerson3Email: Yup.string()
        .email("Invalid email address")
        .max(50, "Must be 50 characters or less"),
      contactPerson4Name: Yup.string().max(
        100,
        "Must be 100 characters or less"
      ),
      contactPerson4PhoneNumber: Yup.string()
        .max(10, "Must be 10 digits")
        .min(10, "Must be 10 digits")
        .matches(/^[0-9]+$/, "Must contain only digits"),
      contactPerson4Email: Yup.string()
        .email("Invalid email address")
        .max(50, "Must be 50 characters or less"),
      contactPerson5Name: Yup.string().max(
        100,
        "Must be 100 characters or less"
      ),
      contactPerson5PhoneNumber: Yup.string()
        .max(10, "Must be 10 digits")
        .min(10, "Must be 10 digits")
        .matches(/^[0-9]+$/, "Must contain only digits"),
      contactPerson5Email: Yup.string()
        .email("Invalid email address")
        .max(50, "Must be 50 characters or less"),
      latittude: Yup.string().max(255, "Must be 255 characters or less"),
      longitude: Yup.string().max(255, "Must be 255 characters or less"),
    }),

    onSubmit: (values) => {
      values.isDeleted = false;
      if (searchParams.get("Id") == null) {
        axiosAuth
          // .post("/api/Authentication/EmployerSignup", values)
          .post("/api/Employers", values)
          .then((response) => {
            if (response.status === 200) {
              setLoading(false);
              navigate(-1);
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      } else {
        axiosAuth
          .put("/api/Employers", values)
          .then((response) => {
            if (response.status === 200) {
              setLoading(false);
              navigate(-1);
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      }
    },
  });
  //UseEffects
  useEffect(() => {
    if (searchParams.get("Id") != null) {
      let id = searchParams.get("Id");
      axiosAuth
        .get("/api/Employers/" + id)
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            let tempData = response.data;

            formik.setValues(tempData);
          } else {
            console.log("Error");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  console.log("formik", formik.values);

  return (
    <>
      <Grid maxWidth="xl" sx={{ marginX: "auto", paddingY: 4, paddingX: 2 }}>
        <Card variant="outlined" sx={{ padding: 2 }}>
          <CardHeader
            avatar={<AccountBalanceIcon color="primary" />}
            title={<Typography variant="h5">Employer Form</Typography>}
            sx={{ paddingBottom: 0 }}
          />
          <Divider sx={{ marginY: 2 }} />
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12}>
              <form onSubmit={formik.handleSubmit}>
                <Typography variant="h6">Personal Details</Typography>
                <Divider sx={{ marginBottom: 3, marginTop: 1 }} />
                <Grid container spacing={2}>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="name"
                      label="Name *"
                      onChange={formik.handleChange}
                      value={formik.values.name}
                      fullWidth
                      error={formik.touched.name && Boolean(formik.errors.name)}
                      helperText={formik.touched.name && formik.errors.name}
                    />
                  </Grid>

                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="email"
                      label="Email Address*"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                      fullWidth
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="phoneNumber"
                      label="Phone Number *"
                      onChange={formik.handleChange}
                      value={formik.values.phoneNumber}
                      fullWidth
                      error={
                        formik.touched.phoneNumber &&
                        Boolean(formik.errors.phoneNumber)
                      }
                      helperText={
                        formik.touched.phoneNumber && formik.errors.phoneNumber
                      }
                    />
                  </Grid>
                </Grid>
                <Typography variant="h6" sx={{ mt: 2 }}>
                  Company Details
                </Typography>
                <Divider sx={{ marginBottom: 3, marginTop: 1 }} />
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      name="name"
                      label="Company Name"
                      onChange={formik.handleChange}
                      value={formik.values.name}
                      fullWidth
                      error={formik.touched.name && Boolean(formik.errors.name)}
                      helperText={formik.touched.name && formik.errors.name}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="addressLine1"
                      label="Address Line 1"
                      onChange={formik.handleChange}
                      value={formik.values.addressLine1}
                      fullWidth
                      error={
                        formik.touched.addressLine1 &&
                        Boolean(formik.errors.addressLine1)
                      }
                      helperText={
                        formik.touched.addressLine1 &&
                        formik.errors.addressLine1
                      }
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="addressLine2"
                      label="Address Line 2"
                      onChange={formik.handleChange}
                      value={formik.values.addressLine2}
                      fullWidth
                      error={
                        formik.touched.addressLine2 &&
                        Boolean(formik.errors.addressLine2)
                      }
                      helperText={
                        formik.touched.addressLine2 &&
                        formik.errors.addressLine2
                      }
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>State</InputLabel>
                      <Select
                        name="state"
                        label="State"
                        onChange={formik.handleChange}
                        value={formik.values.state}
                        error={
                          formik.touched.state && Boolean(formik.errors.state)
                        }
                        helperText={formik.touched.state && formik.errors.state}
                      >
                        {stateOptions.map((options) => (
                          <MenuItem value={options.value}>
                            {options.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="district"
                      label="District"
                      onChange={formik.handleChange}
                      value={formik.values.district}
                      fullWidth
                      error={
                        formik.touched.city && Boolean(formik.errors.district)
                      }
                      helperText={
                        formik.touched.district && formik.errors.district
                      }
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="taluka"
                      label="Taluka"
                      onChange={formik.handleChange}
                      value={formik.values.taluka}
                      fullWidth
                      error={
                        formik.touched.city && Boolean(formik.errors.taluka)
                      }
                      helperText={formik.touched.taluka && formik.errors.taluka}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="city"
                      label="City/Town"
                      onChange={formik.handleChange}
                      value={formik.values.city}
                      fullWidth
                      error={formik.touched.city && Boolean(formik.errors.city)}
                      helperText={formik.touched.city && formik.errors.city}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="pinCode"
                      label="Pin Code"
                      onChange={formik.handleChange}
                      value={formik.values.pinCode}
                      fullWidth
                      error={
                        formik.touched.pinCode && Boolean(formik.errors.pinCode)
                      }
                      helperText={
                        formik.touched.pinCode && formik.errors.pinCode
                      }
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="website"
                      label="Website"
                      onChange={formik.handleChange}
                      value={formik.values.website}
                      fullWidth
                      error={
                        formik.touched.website && Boolean(formik.errors.website)
                      }
                      helperText={
                        formik.touched.website && formik.errors.website
                      }
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Grade Type</InputLabel>
                      <Select
                        name="gradeType"
                        label="Grade Type"
                        onChange={formik.handleChange}
                        value={formik.values.gradeType}
                        error={
                          formik.touched.gradeType &&
                          Boolean(formik.errors.gradeType)
                        }
                      >
                        <MenuItem value={1}>Grade A</MenuItem>
                        <MenuItem value={2}>Grade B</MenuItem>
                        <MenuItem value={3}>Grade C</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={6} xs={12}></Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="latittude"
                      label="Latitude"
                      onChange={formik.handleChange}
                      value={formik.values.latittude}
                      fullWidth
                      error={
                        formik.touched.latittude &&
                        Boolean(formik.errors.latittude)
                      }
                      helperText={
                        formik.touched.latittude && formik.errors.latittude
                      }
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="longitude"
                      label="Longitude"
                      onChange={formik.handleChange}
                      value={formik.values.longitude}
                      fullWidth
                      error={
                        formik.touched.longitude &&
                        Boolean(formik.errors.longitude)
                      }
                      helperText={
                        formik.touched.longitude && formik.errors.longitude
                      }
                    />
                  </Grid>
                </Grid>
                <Typography variant="h6" sx={{ mt: 2 }}>
                  Contact Person
                </Typography>
                <Divider sx={{ marginBottom: 3, marginTop: 1 }} />
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson1Name"
                      label="Contact Person 1 Name"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson1Name}
                      fullWidth
                      error={
                        formik.touched.contactPerson1Name &&
                        Boolean(formik.errors.contactPerson1Name)
                      }
                      helperText={
                        formik.touched.contactPerson1Name &&
                        formik.errors.contactPerson1Name
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson1PhoneNumber"
                      label="Contact Person 1 PhoneNumber"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson1PhoneNumber}
                      fullWidth
                      error={
                        formik.touched.contactPerson1PhoneNumber &&
                        Boolean(formik.errors.contactPerson1PhoneNumber)
                      }
                      helperText={
                        formik.touched.contactPerson1PhoneNumber &&
                        formik.errors.contactPerson1PhoneNumber
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson1Email"
                      label="Contact Person 1 Email"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson1Email}
                      fullWidth
                      error={
                        formik.touched.contactPerson1Email &&
                        Boolean(formik.errors.contactPerson1Email)
                      }
                      helperText={
                        formik.touched.contactPerson1Email &&
                        formik.errors.contactPerson1Email
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson2Name"
                      label="Contact Person 2 Name"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson2Name}
                      fullWidth
                      error={
                        formik.touched.contactPerson2Name &&
                        Boolean(formik.errors.contactPerson2Name)
                      }
                      helperText={
                        formik.touched.contactPerson2Name &&
                        formik.errors.contactPerson2Name
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson2PhoneNumber"
                      label="Contact Person 2 PhoneNumber"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson2PhoneNumber}
                      fullWidth
                      error={
                        formik.touched.contactPerson2PhoneNumber &&
                        Boolean(formik.errors.contactPerson2PhoneNumber)
                      }
                      helperText={
                        formik.touched.contactPerson2PhoneNumber &&
                        formik.errors.contactPerson2PhoneNumber
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson2Email"
                      label="Contact Person 2 Email"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson2Email}
                      fullWidth
                      error={
                        formik.touched.contactPerson2Email &&
                        Boolean(formik.errors.contactPerson2Email)
                      }
                      helperText={
                        formik.touched.contactPerson2Email &&
                        formik.errors.contactPerson2Email
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson3Name"
                      label="Contact Person 3 Name"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson3Name}
                      fullWidth
                      error={
                        formik.touched.contactPerson3Name &&
                        Boolean(formik.errors.contactPerson3Name)
                      }
                      helperText={
                        formik.touched.contactPerson3Name &&
                        formik.errors.contactPerson3Name
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson3PhoneNumber"
                      label="Contact Person 3 PhoneNumber"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson3PhoneNumber}
                      fullWidth
                      error={
                        formik.touched.contactPerson3PhoneNumber &&
                        Boolean(formik.errors.contactPerson3PhoneNumber)
                      }
                      helperText={
                        formik.touched.contactPerson3PhoneNumber &&
                        formik.errors.contactPerson3PhoneNumber
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson3Email"
                      label="Contact Person 3 Email"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson3Email}
                      fullWidth
                      error={
                        formik.touched.contactPerson3Email &&
                        Boolean(formik.errors.contactPerson3Email)
                      }
                      helperText={
                        formik.touched.contactPerson3Email &&
                        formik.errors.contactPerson3Email
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson4Name"
                      label="Contact Person 4 Name"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson4Name}
                      fullWidth
                      error={
                        formik.touched.contactPerson4Name &&
                        Boolean(formik.errors.contactPerson4Name)
                      }
                      helperText={
                        formik.touched.contactPerson4Name &&
                        formik.errors.contactPerson4Name
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson4PhoneNumber"
                      label="Contact Person 4 Phone Number"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson4PhoneNumber}
                      fullWidth
                      error={
                        formik.touched.contactPerson4PhoneNumber &&
                        Boolean(formik.errors.contactPerson4PhoneNumber)
                      }
                      helperText={
                        formik.touched.contactPerson4PhoneNumber &&
                        formik.errors.contactPerson4PhoneNumber
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson4Email"
                      label="Contact Person 4 Email"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson4Email}
                      fullWidth
                      error={
                        formik.touched.contactPerson4Email &&
                        Boolean(formik.errors.contactPerson4Email)
                      }
                      helperText={
                        formik.touched.contactPerson4Email &&
                        formik.errors.contactPerson4Email
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson5Name"
                      label="Contact Person 5 Name"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson5Name}
                      fullWidth
                      error={
                        formik.touched.contactPerson5Name &&
                        Boolean(formik.errors.contactPerson5Name)
                      }
                      helperText={
                        formik.touched.contactPerson5Name &&
                        formik.errors.contactPerson5Name
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson5PhoneNumber"
                      label="Contact Person 5 Phone Number"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson5PhoneNumber}
                      fullWidth
                      error={
                        formik.touched.contactPerson5PhoneNumber &&
                        Boolean(formik.errors.contactPerson5PhoneNumber)
                      }
                      helperText={
                        formik.touched.contactPerson5PhoneNumber &&
                        formik.errors.contactPerson5PhoneNumber
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      name="contactPerson5Email"
                      label="Contact Person 5 Email"
                      onChange={formik.handleChange}
                      value={formik.values.contactPerson5Email}
                      fullWidth
                      error={
                        formik.touched.contactPerson5Email &&
                        Boolean(formik.errors.contactPerson5Email)
                      }
                      helperText={
                        formik.touched.contactPerson5Email &&
                        formik.errors.contactPerson5Email
                      }
                    />
                  </Grid>
                </Grid>
                {formik.values?.id != 0 && (
                  <>
                    <Typography variant="h6" sx={{ mt: 2 }}>
                      Employer Specialization
                    </Typography>
                    <Divider sx={{ marginBottom: 3, marginTop: 1 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <EmployerSpecialization
                          employerId={formik.values?.id}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
                <Divider sx={{ my: 2 }} />
                <Grid>
                  <Button variant="contained" type="submit">
                    Save
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      navigate(-1);
                    }}
                    sx={{ marginLeft: 2 }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default EmployerForm;
